(function () {
  const rotatorSelector = '[data-announcement-banner-rotator]';
  const slideSelector = '[data-announcement-banner-slide]';

  function setSlideState(slides, activeIndex) {
    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;

      slide.toggleAttribute('hidden', !isActive);
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (isActive) {
        slide.removeAttribute('tabindex');
      } else {
        slide.setAttribute('tabindex', '-1');
      }
    });
  }

  function initRotator(rotator) {
    if (rotator.dataset.announcementBannerInitialized === 'true') return;

    const slides = Array.from(rotator.querySelectorAll(slideSelector));
    if (slides.length < 2) return;

    rotator.dataset.announcementBannerInitialized = 'true';

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const rotationInterval = Number.parseInt(rotator.dataset.rotationInterval, 10) || 5000;
    let activeIndex = slides.findIndex((slide) => !slide.hasAttribute('hidden'));
    let timer = null;
    let isHovering = false;
    let hasFocusWithin = false;

    if (activeIndex < 0) activeIndex = 0;
    setSlideState(slides, activeIndex);

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function showNext() {
      activeIndex = (activeIndex + 1) % slides.length;
      setSlideState(slides, activeIndex);
    }

    function play() {
      stop();
      if (isHovering || hasFocusWithin || reducedMotionQuery.matches) return;
      timer = window.setInterval(showNext, rotationInterval);
    }

    function pauseForHover() {
      isHovering = true;
      stop();
    }

    function resumeAfterHover() {
      isHovering = false;
      play();
    }

    function pauseForFocus() {
      hasFocusWithin = true;
      stop();
    }

    function resumeAfterFocus() {
      hasFocusWithin = false;
      play();
    }

    rotator.addEventListener('mouseenter', pauseForHover);
    rotator.addEventListener('mouseleave', resumeAfterHover);
    rotator.addEventListener('focusin', pauseForFocus);
    rotator.addEventListener('focusout', (event) => {
      if (event.relatedTarget && rotator.contains(event.relatedTarget)) return;
      resumeAfterFocus();
    });

    reducedMotionQuery.addEventListener('change', play);
    play();
  }

  function initAnnouncementBanners(root) {
    root.querySelectorAll(rotatorSelector).forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAnnouncementBanners(document));
  } else {
    initAnnouncementBanners(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBanners(event.target);
  });
})();
